import { dependencies } from '@pn/core/dependencies';
import { getPointsLayerId, getSourceId } from '@pn/core/domain/workspace';
import { useWorkspaceStorage } from '@pn/core/storage';
import { isNil } from 'lodash-es';
import React from 'react';
import { useParams } from 'react-router-dom';

export function useAutoSetCurrentRequestedIdFeatureState(tableOnly = false) {
  const { id } = useParams();

  const { workspaceItemSelected } = useWorkspaceStorage();

  React.useEffect(() => {
    const { map } = dependencies;

    if (tableOnly || isNil(id) || isNil(workspaceItemSelected)) return;

    for (const layer of workspaceItemSelected.map.layers) {
      map.setFeatureState({
        sourceId: getSourceId(layer.id),
        sourceLayer: layer.sourceLayer,
        featureId: id,
        featureState: {
          isSelected: true,
        },
      });

      if (layer.renderAsPoints) {
        map.setFeatureState({
          sourceId: getSourceId(getPointsLayerId(layer.id)),
          featureId: id,
          featureState: {
            isSelected: true,
          },
        });
      }
    }

    return () => {
      for (const layer of workspaceItemSelected.map.layers) {
        map.unsetFeatureState({
          sourceId: getSourceId(layer.id),
          sourceLayer: layer.sourceLayer,
          featureId: id,
          featureStateFields: ['isSelected'],
        });

        if (layer.renderAsPoints) {
          map.unsetFeatureState({
            sourceId: getSourceId(getPointsLayerId(layer.id)),
            featureId: id,
            featureStateFields: ['isSelected'],
          });
        }
      }
    };
  }, [tableOnly, id, workspaceItemSelected]);
}
